import HttpFactory from '../HttpFactory'
import type IBasicArrayResponse from '../interfaces/IBasicArrayResponse'

class TranslationsModule extends HttpFactory {
  private RESOURCE = 'api/translations'

  async getAllTranslations () {
    return await this.callUseAsyncData<IBasicArrayResponse>(
      'GET',
      `${this.RESOURCE}`
    )
  }

  async fetchAllTranslations () {
    return await this.callFetch<IBasicArrayResponse>(
      'GET',
      `${this.RESOURCE}`
    )
  }
}

export default TranslationsModule
